import * as React from 'react';
import { useParams } from 'react-router';
import Page from '../../../components/Page';
import SubscriptionContainer from '../../subscriptions/containers/SubscriptionContainer';
import UserInfoContainer from '../containers/UserInfoContainer';

const UserSubscriptionPage: React.FC = () => {
  const { id } = useParams();

  return (
    <Page header="userSubscription">
      <UserInfoContainer userId={id!} />
      <SubscriptionContainer userId={id!} />
    </Page>
  );
};

export default UserSubscriptionPage;
